import {mapOptimizerSettingsResponse} from '../../../selectors/optimizer'
import {useUrlParam} from '../../useUrlParam'
import {usePlannerQuery} from '../usePlannerQuery'

export const useOptizerSettings = () => {
  const plantCode = useUrlParam('plantCode')

  return usePlannerQuery('optimizerSettings', [plantCode], {select: mapOptimizerSettingsResponse})
}
